import searchMutations from "./mutations.js";
import searchActions from "./actions.js";
import searchGetters from "./getters.js";

export default {
    namespaced: true,
    state() {
        return {
            advancedSearchState:false,
            advancedSearchDataFromStore:{}
        };
    },
    mutations: searchMutations,
    actions: searchActions,
    getters: searchGetters,
};